import {Pipe, PipeTransform} from '@angular/core';
import {NavType} from "./ac-nav-auto/ac-nav-auto.service";

@Pipe({
    name: 'routeBuilder'
})
export class RouteBuilderPipe implements PipeTransform {

    transform(navType: NavType | string, leading?: any, trailing?: any, ...args): any {
        const value = typeof navType === 'string' ? navType : navType?.urlWithParams || navType?.routeConfig.path;

        let paths = [
            leading === true && '',
            value,
            leading !== true && leading !== false ? leading : undefined,
            trailing !== true ? trailing : undefined,
            ...args,
            trailing === true ? '' : undefined];

        paths = paths.filter((x) => x !== undefined);
        return paths.join('/');
    }

}
